import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";

export default function FinalCta() {
  return (
    <section className="px-4 md:px-8 lg:px-12 py-20 md:py-28 bg-background-100/70">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-6 text-center">
        <Reveal className="flex flex-col items-center gap-6">
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-900">
            Encuentra un lugar para vivir. Encuentra una oportunidad para invertir.
          </h2>
          <p className="text-base md:text-lg text-foreground-500">
            Conoce los proyectos de Inmobiliaria ADJ.
          </p>
          <Link
            to="/proyectos"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm md:text-base font-semibold px-8 py-3.5 transition-colors duration-300 whitespace-nowrap"
          >
            VER PROYECTOS
          </Link>
        </Reveal>
      </div>
    </section>
  );
}